import { DatePicker, Form, FormInstance, Input, Select, Typography } from 'antd';
import dayjs from 'dayjs';
import { FC } from 'react';
import { DATE_FORMAT } from '../../../../../../../../constants';
import { Country } from '../../../../../../../../types/country';
import { IdentityVerificationCaseV1CaseDetails, IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails } from '../../../../../../../../generated';
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export interface CaseDetailsApplicationPassportDetailFormProps {
  form: FormInstance<IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails>;
  caseDetails: IdentityVerificationCaseV1CaseDetails;
  countryData: Country[];
}

export const CaseDetailsApplicationPassportDetailForm: FC<CaseDetailsApplicationPassportDetailFormProps> = ({ form, caseDetails, countryData }) => {
  return (
    <Form
      form={form}
      style={{ width: '100%' }}
      layout="vertical"
      initialValues={
        caseDetails?.application?.passportDetails || {
          passportCountry: '',
          passportExpiresAt: '',
          passportIssuedAt: '',
          passportNumber: ''
        }
      }
    >
      <Typography.Title level={5}>Passport Details </Typography.Title>
      <Form.Item
        label="Passport Country"
        name={['passportCountry']}
        rules={[
          {
            required: true,
            message: 'Please select a passport country'
          }
        ]}
      >
        <Select style={{ width: 300 }}>
          {countryData?.map((country: Country) => (
            <Select.Option key={country.countryCode} value={country.countryCode}>
              {country.countryName}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <div style={{ display: 'flex', gap: 10 }}>
        <Form.Item
          name={['passportIssuedAt']}
          valuePropName="value"
          rules={[
            {
              required: true,
              message: 'Passport issue date is required.'
            }
          ]}
          label="Passport Issue Date"
          getValueProps={(value) => ({
            value: value ? dayjs(value).utc() : ''
          })}
        >
          <DatePicker
            style={{ width: 150 }}
            value={
              caseDetails?.application?.passportDetails?.passportIssuedAt
                ? dayjs(caseDetails?.application?.passportDetails.passportIssuedAt).format(DATE_FORMAT).toUpperCase()
                : ''
            }
            format={DATE_FORMAT}
            disabledDate={(current) => current && current > dayjs().utc().endOf('day')}
          />
        </Form.Item>
        <Form.Item
          name={['passportExpiresAt']}
          valuePropName="value"
          rules={[
            {
              required: true,
              message: 'Passport expiration date is required.'
            }
          ]}
          label="Passport Expiration Date"
          getValueProps={(value) => ({
            value: value ? dayjs(value).utc() : ''
          })}
        >
          <DatePicker
            style={{ width: 150 }}
            value={
              caseDetails?.application?.passportDetails?.passportExpiresAt
                ? dayjs(caseDetails?.application?.passportDetails?.passportExpiresAt).format(DATE_FORMAT).toUpperCase()
                : ''
            }
            format={(value) => value.format(DATE_FORMAT).toUpperCase()}
            />
        </Form.Item>
      </div>
      <Form.Item
        label="Passport Number"
        name={['passportNumber']}
        rules={[
          { required: true, message: 'Passport number is required.' },
          {
            validator: (_, value) => (/^[A-Z]+$/.test(value) ? Promise.reject(new Error('Invalid Passport Number')) : Promise.resolve())
          }
        ]}
      >
        <Input
          maxLength={9}
          minLength={9}
          style={{ width: 300 }}
          onInput={(e) => ((e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.toUpperCase())}
        />
      </Form.Item>
    </Form>
  );
};
